import { render, staticRenderFns } from "./dispense.vue?vue&type=template&id=1501a347&scoped=true"
import script from "./dispense.vue?vue&type=script&lang=js"
export * from "./dispense.vue?vue&type=script&lang=js"
import style0 from "./dispense.vue?vue&type=style&index=0&id=1501a347&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501a347",
  null
  
)

export default component.exports